<template>
    <div>
        <base-input
            v-model="payment.phone_number"
            v-validate="{ required: true, regex: /(\(?\d{2}\)?)?9?\d{4}-?\d{4}$/ }"
            :name="$t('cart.recurrence.phone_number')"
            :placeholder="$t('cart.recurrence.phone_number')"
            :error="errors.first($t('cart.recurrence.phone_number'))"
            type="text"
        ></base-input>
        <base-input
            v-model="payment.birth"
            v-validate="'required'"
            :name="$t('cart.recurrence.birth')"
            :placeholder="$t('cart.recurrence.birth')"
            :error="errors.first($t('cart.recurrence.birth'))"
            v-mask="'##/##/####'"
            type="text"
        ></base-input>
    </div>
</template>

<script>
    import Card from '../../argon/components/Cards/Card';
    import BaseInput from '../../argon/components/Inputs/BaseInput';
    import BaseButton from '../../argon/components/BaseButton';

    export default {
    emits: ['input', 'update:modelValue'],
        name: 'ChangePaymentBillet',
        components: {
            Card,
            BaseInput,
            BaseButton
        },
        props: {
            modelValue: {
                type: Object,
                required: true
            },
            color: {
                type: Object,
                required: true
            }
        },
        data() {
            return {}
        },
        computed: {
            payment: {
                get() {
                    return this.modelValue
                },
                set(value) {
                    this.$emit('update:modelValue', value);
                    this.$emit('input', value);
                }
            }
        }
    }
</script>
